export default __webpack_public_path__ + "static/media/Joker_edit.19794848.jpg";